module.exports = __webpack_public_path__ + "img/ride-ceva.18008e5c.svg";